import { createRoute, getPathForAllPortals } from "utilities/flatRoutes/routes";

interface ISubmittalParams {
    id: string;
    jobId: number;
}

export const submittalDetailsPath = "/Submittal/:id/:jobId";
export const submittalDetailsRoute = createRoute<ISubmittalParams>(
    getPathForAllPortals(submittalDetailsPath),
    "Submittal",
);
